export default "__VITE_ASSET__BtnWoo8c__"